import LoginHandlerContainer from './login-callback-container';

export default LoginHandlerContainer;
